import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAcPowerIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 30,
	viewBox: "0 0 28 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8.45216 14.516V13.8599H1.80177L7.78613 3.20338V9.89354C7.78613 10.0725 7.85571 10.2415 7.98494 10.3608C8.11417 10.48 8.28317 10.5596 8.45216 10.5596H15.1026L9.1182 21.2161V14.5259C9.1182 14.347 9.04861 14.178 8.91938 14.0587C8.80009 13.9394 8.62116 13.8599 8.45216 13.8599V14.516H7.78613V23.751C7.78613 24.0492 7.99489 24.3176 8.28317 24.3872C8.58139 24.4667 8.88956 24.3276 9.03867 24.0691L16.8223 10.2116C16.9317 10.0029 16.9317 9.75437 16.8223 9.55555C16.703 9.35674 16.4843 9.2275 16.2457 9.2275H9.12814V0.658538C9.12814 0.360314 8.91938 0.0919125 8.6311 0.0223269C8.33287 -0.0571994 8.02471 0.0819717 7.8756 0.340432L0.0820116 14.188C-0.0273372 14.3967 -0.0273372 14.6452 0.0820116 14.8441C0.201301 15.0429 0.419999 15.1721 0.658578 15.1721H8.44222V14.516H8.45216Z",
			fill: "#2C3F81"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_10_26",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 8,
			y: 9,
			width: 20,
			height: 21,
			children: /* @__PURE__ */ _jsx("rect", {
				x: 8.94672,
				y: 9.9408,
				width: 19.0533,
				height: 19.6935,
				fill: "#1F3171"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_10_26)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M18.4718 24.3903C18.828 24.3903 19.1476 24.2597 19.3968 24.0021C19.6452 23.7453 19.7657 23.4231 19.7657 23.0698C19.7657 22.7165 19.6452 22.3942 19.3968 22.1375C19.1476 21.8798 18.828 21.7492 18.4718 21.7492C18.1157 21.7492 17.7961 21.8798 17.5469 22.1375C17.2984 22.3942 17.178 22.7165 17.178 23.0698C17.178 23.4231 17.2984 23.7453 17.5469 24.0021C17.7961 24.2597 18.1157 24.3903 18.4718 24.3903ZM18.4718 21.1081C18.828 21.1081 19.1476 20.9775 19.3968 20.7198C19.6452 20.4631 19.7657 20.1408 19.7657 19.7875V16.5053C19.7657 16.152 19.6452 15.8297 19.3968 15.573C19.1476 15.3153 18.828 15.1847 18.4718 15.1847C18.1157 15.1847 17.7961 15.3153 17.5469 15.573C17.2984 15.8297 17.178 16.152 17.178 16.5053V19.7875C17.178 20.1408 17.2984 20.4631 17.5469 20.7198C17.7961 20.9775 18.1157 21.1081 18.4718 21.1081ZM18.4718 27.4932C17.4411 27.4932 16.4787 27.2914 15.5793 26.8903C14.6701 26.4848 13.8832 25.9366 13.2144 25.2454C12.5456 24.554 12.0136 23.7389 11.6196 22.7951C11.2295 21.8608 11.033 20.8598 11.033 19.7875C11.033 18.7152 11.2295 17.7143 11.6196 16.78C12.0136 15.8361 12.5456 15.021 13.2144 14.3297C13.8832 13.6385 14.6701 13.0903 15.5793 12.6847C16.4787 12.2836 17.4411 12.0819 18.4718 12.0819C19.5026 12.0819 20.465 12.2836 21.3643 12.6847C22.2736 13.0903 23.0605 13.6385 23.7292 14.3297C24.3981 15.021 24.9301 15.8361 25.3241 16.78C25.7142 17.7143 25.9107 18.7152 25.9107 19.7875C25.9107 20.8598 25.7142 21.8608 25.3241 22.7951C24.9301 23.7389 24.3981 24.554 23.7292 25.2454C23.0605 25.9366 22.2736 26.4848 21.3643 26.8903C20.465 27.2914 19.5026 27.4932 18.4718 27.4932Z",
				fill: "#1F3171",
				stroke: "#1F3171"
			})
		})
	]
});
export default SvgAcPowerIcon;
